import { useEffect, useState } from "react";

export const useProgramme = <T extends object>() => {
  const handle_programme = (data: any, assistantId: string) => {
    let arr:any = [];
    data.map((item: any) => {
        let o = []
        const hashIndex = item.socialmedia_text.indexOf('#');
        let str = '';
        if (hashIndex !== -1) {
            str = item.socialmedia_text.slice(hashIndex);
        }
        for (let key in item) {
            if (key === 'socialmedia_text') {
                let k = item[key].slice(0, hashIndex);
                o.push({
                    type: 'paragraph',
                    prop: key,
                    msgId: item.id,
                    socialmedia: item.socialmedia,
                    assistantId: assistantId,
                    children: [
                        { text: k }
                    ]
                })
            }
        }
        o.push({
            type: 'highlight',
            prop: 'socialmedia_text',
            highlight: true,
            children: [
                { text: str }
            ]
        })
        arr.push({
            ...item,
            data: o,
        })
    });
    return arr;
  }
  const handle_formatData = (data: any, row: any) => {
    let o = []
    const hashIndex = data.indexOf('#');
    let str = '';
    if (hashIndex !== -1) {
        str = data.slice(hashIndex);
    }
    let k = data.slice(0, hashIndex);
    o.push({
        type: 'paragraph',
        prop: 'socialmedia_text',
        msgId: row.msgId,
        socialmedia: row.socialmedia,
        assistantId: row.assistantId,
        children: [
            { text: k }
        ]
    })
    o.push({
        type: 'highlight',
        prop: 'socialmedia_text',
        highlight: true,
        children: [
            { text: str }
        ]
    });
    return o;
  }
  const handle_fromObj =  (data: any, row: any) => {
    let o = []
    const hashIndex = data.socialmedia_text.indexOf('#');
    let str = '';
    if (hashIndex !== -1) {
        str = data.socialmedia_text.slice(hashIndex);
    }
    for (let key in data) {
        if (key === 'socialmedia_text') {
            let k = data[key].slice(0, hashIndex);
            o.push({
                type: 'paragraph',
                prop: key,
                msgId: row.id,
                socialmedia: row.socialmedia,
                assistantId: row.assistantId,
                children: [
                    { text: k }
                ]
            })
        }
    }
    o.push({
        type: 'highlight',
        prop: 'socialmedia_text',
        highlight: true,
        children: [
            { text: str }
        ]
    });
    return o;
  }
  return {
    handle_programme,
    handle_formatData,
    handle_fromObj
  };
};